import { createAction } from '@mews/framework';
import { createUUID } from '@mews/std';
import { CommanderThunkAction } from '@mews-commander/types';
import { getResourceIdsByFloorId } from '../selectors/resources';
import { getSelectedEntityId } from '../../entityManagement/selectors';
import { DELETE_ENTITY_SUCCEEDED, stopEntityDeleting } from '../../entityManagement/actions';
import { deleteResources } from './resources';
import { FLOOR_ADDED, FLOOR_EDITED, FLOOR_DELETED } from './types';

export const addFloor =
    ({ name, id: floorId }: { name: string; id?: string }): CommanderThunkAction =>
    (dispatch) => {
        const id = floorId || createUUID();
        dispatch(createAction(FLOOR_ADDED, { id, name }));
    };
export const editFloor = ({ id, name }: { id: string; name: string }) => createAction(FLOOR_EDITED, { id, name });
export const deleteFloor =
    (_ownerId: string, scope: string): CommanderThunkAction =>
    (dispatch, getState) => {
        const state = getState();
        const id = getSelectedEntityId(state, { scope });
        const floorResources = getResourceIdsByFloorId(state, { id });

        dispatch(createAction(FLOOR_DELETED, { id }));
        dispatch(stopEntityDeleting(scope));
        dispatch(createAction(DELETE_ENTITY_SUCCEEDED, undefined, { scope }));
        dispatch(deleteResources(floorResources));
    };
